import { render } from "./NegatifSlider.vue?vue&type=template&id=7e881846&scoped=true"
import script from "./NegatifSlider.vue?vue&type=script&lang=js"
export * from "./NegatifSlider.vue?vue&type=script&lang=js"

import "./NegatifSlider.vue?vue&type=style&index=0&id=7e881846&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e881846"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCarousel,QCarouselSlide});
